export default {"src":"/_next/static/media/couch_64.64e6714c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};